import { put } from "@redux-saga/core/effects";

import { FormsService } from "./../../../services/forms";

import { UpdateLogicRequestActionType } from "./../types";

import { updateLogicFailure, updateLogicSuccess } from "./../actionCreators";

export function* updateLogicData({ payload }: UpdateLogicRequestActionType) {
    try {
        const { rules } = payload;

        yield FormsService.updateFormComponent({ data: [{ logic: { rules: rules } }] });

        yield put(updateLogicSuccess({ data: { rules } }));
    } catch (error) {
        yield put(updateLogicFailure({ error: true }));
    }
}
